export default __webpack_public_path__ + "static/media/ProjectPythonDownloadVid.d10be0f2.png";